const updateHeaderExtensions = (transceiver, headerExtensionsToChange) => {
  const headerExtensions = transceiver.getHeaderExtensionsToNegotiate();
  let shouldUpdate = false;
  headerExtensionsToChange.forEach(({ condition, uri, direction }) => {
    const headerExtension = headerExtensions.find(ext =>
      ext.uri === uri && ext.direction !== direction);
    if (!headerExtension || !condition(transceiver)) return;
    headerExtension.direction = direction;
    shouldUpdate = true;
  });
  if (!shouldUpdate) return;
  transceiver.setHeaderExtensionsToNegotiate(headerExtensions);
};

const handleHeaderExtensionsNegotiation = async (
  peerConnection,
  mods = {
    removeVideoOrientation: false,
  }
) => {
  const headerExtensionsToChange = [];
  if (mods.removeVideoOrientation) {
    headerExtensionsToChange.push({
      condition: transceiver => transceiver.sender.track.kind === 'video',
      uri: 'urn:3gpp:video-orientation',
      direction: 'stopped',
    });
  }
  peerConnection.getTransceivers().forEach(
    transceiver => updateHeaderExtensions(transceiver, headerExtensionsToChange));
};

export default handleHeaderExtensionsNegotiation;
